let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aikvX"), load("jrKPL"), load("joJy8"), load("aHE9G"), load("c6MKV"), load("dnwTC")]).then(() => parcelRequire('3Jp28'));